import { Link } from "react-router-dom";
import { Text, Img, Heading } from "..";
import React from "react";

const PostItem = ({
  headingText = "How To Create Restaurant P&L Trend Analysis?",
  descriptionText = "A Profit and Loss Statement is one of the most important financial tools that a restaurant owner has to evaluate their operation in detail...",
  likeIconImage = "images/img_heart_rounded.svg",
  likeCountText = "30",
  commentCountText = "100",
  shareCountText = "50",
  ...props
}) => {
  return (
    <div
      {...props}
      className={`${props.className} flex flex-col justify-center sm:justify-center sm:items-start w-[358px] p-4 border-gray-100 border-[0.5px] border-solid bg-white-a700 rounded-[18px] sm:min-w-[358px]`}
    >
      <Link to="/postspage" state={{ post: props.slug }}>
        <Heading
          as="h6"
          className="!font-avenirarabic lg:text-[16px] line-clamp-2 min-h-[40px] font-black leading-5"
        >
          {headingText}
        </Heading>
        <Text
          as="p"
          className="w-full !font-avenirarabic text-[12px] font-medium leading-4 tracking-[0.50px] !text-gray-900_02"
        >
          <p className="text-gray-900_02 my-1 line-clamp-3 h-38px">
            {descriptionText}
          </p>
          <span className="font-extrabold text-light_blue-a700">Read More</span>
        </Text>
      </Link>
      <div className="mt-2 flex gap-1 self-stretch">
        <div className="flex items-center gap-1">
          <Img src={likeIconImage} alt="Image" className="h-[16px] self-end" />
          <Text as="p" className="!font-avenirarabic text-[12px] font-medium">
            {likeCountText}
          </Text>
        </div>
        <div className="flex items-center gap-1">
          <Img
            src="images/img_comment_icon.svg"
            alt="Image"
            className="h-[16px] self-end"
          />
          <Text as="p" className="!font-avenirarabic text-[12px] font-medium">
            {commentCountText}
          </Text>
        </div>
        <div className="flex flex-1 items-center">
          <Img
            src="images/img_search_blue_gray_200_1.svg"
            alt="Image"
            className="h-[16px] self-end"
          />
          <Text as="p" className="!font-avenirarabic text-[12px] font-medium">
            {shareCountText}
          </Text>
        </div>
      </div>
    </div>
  );
};

export { PostItem };
